import type { IForemanClient, IForemanClientsToSiteMapping } from '@/types/core/ForemanSiteMapping'
import type { IForemanClientsToSiteMappingForm } from '@/types/core/forms'
import axios from 'axios'

export async function getForemanClientsToSiteMappings(): Promise<IForemanClientsToSiteMapping[]> {
  const res = await axios.get(import.meta.env.VITE_APP_CORE_FOREMAN_SITE_MAPPINGS_ENDPOINT)
  return res.data
}

export async function deleteForemanClientsToSiteMappings(id: number): Promise<any> {
  const res = await axios.delete(`${import.meta.env.VITE_APP_CORE_FOREMAN_SITE_MAPPINGS_ENDPOINT}`, {
    data: { id: id },
  })
  return res.data
}

export async function createForemanClientsToSiteMappings(form: IForemanClientsToSiteMappingForm): Promise<any> {
  const res = await axios.post(import.meta.env.VITE_APP_CORE_FOREMAN_SITE_MAPPINGS_ENDPOINT, form)
  return res.data
}

export async function getForemanClients(): Promise<IForemanClient[]> {
  const res = await axios.get(import.meta.env.VITE_APP_CORE_FOREMAN_CLIENTS_ENDPOINT)
  return res.data
}
